import styles from '@styles/AdminPanel.module.css'
import { es } from 'date-fns/locale'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

const MessagesSection = ({ messages, clearMessages }) => {
  return (
    <div className={styles.messagesSection}>
      <h2>Mensajes de Contacto</h2>
      <div className={styles.messagesContainer}>
        {messages.map((message) => (
          <div key={message.id} className={styles.messageCard}>
            <div className={styles.messageHeader}>
              <h3>{message.name}</h3>
              <span>{format(message.timestamp, 'dd/MM/yyyy HH:mm', { locale: es })}</span>
            </div>
            <p className={styles.messageEmail}>{message.email}</p>
            <p className={styles.messageContent}>{message.message}</p>
          </div>
        ))}
        <button className={styles.clearMessages} onClick={clearMessages}>
          Eliminar Mensajes
        </button>
      </div>
    </div>
  )
}

MessagesSection.propTypes = {
  messages: PropTypes.array.isRequired,
  clearMessages: PropTypes.func.isRequired,
}

export default MessagesSection
